import { Link } from 'react-router-dom';
import { BRAND } from './navigationConfig';

function NavBrand({ onNavigate }) {
  return (
    <Link
      to={BRAND.homePath}
      className="c-nav-bar__brand"
      aria-label={BRAND.title}
      onClick={onNavigate}
    >
      <img
        src="/van-gelder-logo.svg"
        alt=""
        className="c-nav-bar__logo-image"
        width={155}
        height={32}
      />
    </Link>
  );
}

export default NavBrand;
